import { render } from "./BigCard.vue?vue&type=template&id=54b22bab&scoped=true&ts=true"
import script from "./BigCard.vue?vue&type=script&lang=ts"
export * from "./BigCard.vue?vue&type=script&lang=ts"

import "./BigCard.vue?vue&type=style&index=0&id=54b22bab&scoped=true&lang=scss"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b22bab"]])

export default __exports__